import React from "react";
import Modal from "../ui/Modal";

interface ConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmButtonVariant?: "danger" | "primary" | "warning";
  isLoading?: boolean;
}

export default function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText = "Evet",
  cancelText = "İptal",
  confirmButtonVariant = "danger",
  isLoading = false,
}: ConfirmModalProps) {
  const getConfirmButtonClasses = () => {
    const baseClasses = "px-4 py-2 rounded-md font-medium text-sm disabled:opacity-50 disabled:cursor-not-allowed";

    switch (confirmButtonVariant) {
      case "danger":
        return `${baseClasses} bg-red-600 text-white hover:bg-red-700`;
      case "warning":
        return `${baseClasses} bg-yellow-600 text-white hover:bg-yellow-700`;
      case "primary":
      default:
        return `${baseClasses} bg-blue-600 text-white hover:bg-blue-700`;
    }
  };

  const messageLines = message.split('\n');

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm">
      <div className="space-y-4">
        <div className="space-y-2 text-gray-700 break-words">
          {messageLines.map((line, index) => (
            line.trim() === 'Bu işlem geri alınamaz.'
              ? <p key={`${line}-${index}`} className="font-bold">{line}</p>
              : <p key={`${line}-${index}`}>{line}</p>
          ))}
        </div>

        <div className="flex gap-3 justify-end pt-4 border-t border-gray-200">
          {cancelText && (
            <button
              onClick={onClose}
              disabled={isLoading}
              className="px-4 py-2 text-gray-700 bg-gray-100 rounded-md hover:bg-gray-200 disabled:opacity-50 disabled:cursor-not-allowed font-medium text-sm">
              {cancelText}
            </button>
          )}
          <button onClick={onConfirm} disabled={isLoading} className={getConfirmButtonClasses()}>
            {isLoading ? "İşleniyor..." : confirmText}
          </button>
        </div>
      </div>
    </Modal>
  );
}
